import React, { useState, useEffect, useContext, useRef } from "react";
import { DataGrid, gridClasses } from "@mui/x-data-grid";

import { Link, useNavigate } from "react-router-dom";
import { useForm, Controller } from "react-hook-form";
import FormControlLabel from "@mui/material/FormControlLabel";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import {
  Container,
  Card,
  CardContent,
  Grid,
  Typography,
  Divider,
  TextField,
  Radio,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import styled from "styled-components";

import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";

import {
  GET_CLIENT_DATA_BY_NAME,
  CREATE_CLIENT_MUTATION,
} from "../../graphQL/client_qry";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    width: "1400px",
    paddingTop: "7rem",
    //  minWidth: "500px",
  },
  container: {
    padding: theme.spacing(4),
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    borderRadius: "8px",
    minHeight: "870px",
    backgroundColor: "#ffffff",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  errorStyle: {
    marginTop: 0,
    fontSize: 14, //16,
    fontFamily: "Arial",
    paddingLeft: 5,
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  datePickerStyle: {
    marginBottom: 5,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
}));

function ClientAdd() {
  const [loadContent, setLoadContent] = useState(false);
  const [alertMsg, setAlertMsg] = useState([]);
  const [startDate, setStartDate] = useState(dayjs(new Date()));
  const [errorMsg, setErrorMsg] = useState({
    name: "",
    noOfWeeks: "",
    startDate: "",
  });

  const classes = useStyles();
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);

  const [addAccess, setAddAccess] = useState(true);

  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else window.location.href = `${project_url}/signin/?next=${pathname}`;
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        window.location.href = `${project_url}/signin/?next=${pathname}`;
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const tenantName = localStorage.getItem("tenantName");
  const tenantId = localStorage.getItem("tenantId");

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;  
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId")) 
    clientId = localStorage.getItem("clientId");

  const [createClient] = useMutation(CREATE_CLIENT_MUTATION, {
    //refetchQueries: [{ query: FIND_FORM_FOR_CLIENT_QUERY }],
    awaitRefetchQueries: true,
  });

  const [getClientData] = useManualQuery(GET_CLIENT_DATA_BY_NAME, {
    fetchPolicy: "network-only",
  });

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module
    
    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),  
              clientId: parseInt(clientId), 
              moduleName: "Clients",
              modulepageName: "List"     
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {      
      
      let commonActions = accessData.staffModuleAccess.commonActions.split('|');
      
      if(commonActions.find(a => a == "Add"))
        setAddAccess(true);
      else {setAddAccess(false);}
     }
    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

  
   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);

  const handleNameChange = e => {
    setErrorMsg({ name: "" });
  };

  const handleStartDateChange = date => {
    setStartDate(date);
    setErrorMsg({ startDate: "" });
  };

  const validateNoOfWeeks = value => {
    if (parseInt(value) < 1) {
      setErrorMsg({ noOfWeeks: "Enter an integer greater than zero." });
    } else if (parseInt(value) > 99) {
      setErrorMsg({ noOfWeeks: "Enter an integer less than 100." });
    } else if (value.toString().trim() === "") {
      setErrorMsg({ noOfWeeks: "No of Weeks cannot be blank." });
    } else {
      setErrorMsg({ noOfWeeks: "" });
    }
  };

  const onSubmit = async formData => {
    let sDate = new Date(startDate).toLocaleDateString("sv-SE");
    if (!startDate || sDate == "" || sDate == "Invalid Date") {
      setErrorMsg({ startDate: "Start Date cannot be blank" });
      return;
    }

    //check if entered name exist in tenant or not
    const {
      loading: clientLoading,
      error: clientError,
      data: clientData,
    } = await getClientData({
      variables: {
        name: formData.name,
        tenantId: parseInt(tenantId),
        clientUuid: null,
      },
    });

    if (!clientLoading && clientData && clientData.getClientDataByName) {
      setErrorMsg({
        name: "This name has been exist in tenant, please enter another name.",
      });
    } else {
      setErrorMsg({});
      const { data, error } = await createClient({
        variables: {
          name: formData.name,
          tenantId: parseInt(tenantId),
          termStartDate: startDate.toISOString().slice(0, 10),
          termNoOfWeeks: parseInt(formData.weeks),
        },
      });
      if (error) {
        console.log("Error", error, data);
        setAlertMsg({
          title: "Error",
          msg: "Unfortunately an error occurred.",
        });
      } else if (data && data.createClient) {
        console.log("Success", data);
        setAlertMsg({
          title: "Success",
          msg: "New Client has been successfully added.",
        });

        localStorage.setItem("clientId", data.createClient.client.clientId);
        localStorage.setItem("clientName", data.createClient.client.name);
      }
    }
  };
 
  if (loadContent)
     if (addAccess)
    return (
      <div className={classes.root}>
        <Header breadcrumbs={[{ label: "Add Client", link: null }]} />
        <div className={classes.container}>
          <Box mt={2} mb={2} textAlign="center">
            <Typography variant="body1" style={{ marginBottom: 10 }}>
              Add Client
            </Typography>
          </Box>
          <Divider />
          <form onSubmit={handleSubmit(onSubmit)}>
            <Grid
              container
              spacing={3}
              style={{
                marginTop: 30,
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Client Name"
                  margin="normal"
                  name="name"
                  type="name"
                  variant="outlined"
                  id="name"
                  {...register("name", { required: true })}
                  onChange={handleNameChange}
                />

                {errors.name && errors.name.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    Client Name cannot be blank.
                  </FormHelperText>
                )}

                {errorMsg.name && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.name}
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={4}>
                <TextField
                  className={classes.textFieldStyle}
                  fullWidth
                  label="Term No of Weeks"
                  margin="normal"
                  name="weeks"
                  type="number"
                  defaultValue={5}
                  variant="outlined"
                  onKeyDown={e => {
                    if (e.keyCode >= 65 && e.keyCode <= 90) {
                      e.preventDefault();
                    }
                  }}
                  onChange={e => validateNoOfWeeks(e.target.value)}
                  InputProps={{
                    inputProps: { min: 1, max: 99, pattern: "^[1-9][0-9]?$" },
                  }}
                  id="weeks"
                  {...register("weeks", { required: true })}
                />

                {errors.weeks && errors.weeks.type === "required" && (
                  <FormHelperText className={classes.errorStyle} error>
                    No of Weeks cannot be blank.
                  </FormHelperText>
                )}
                {errorMsg.noOfWeeks && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.noOfWeeks}
                  </FormHelperText>
                )}
              </Grid>
              <Grid
                item
                xs={4}
                style={{
                  display: "flex",
                  flexDirection: "column",
                  marginTop: 15,
                }}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    className={classes.datePickerStyle}
                    value={startDate}
                    label="Term Start Date"
                    id="startDate"
                    name="startDate"
                    onChange={newDate => handleStartDateChange(newDate)}
                  />
                </LocalizationProvider>
                {errorMsg.startDate && (
                  <FormHelperText className={classes.errorStyle} error>
                    {errorMsg.startDate}
                  </FormHelperText>
                )}
              </Grid>
            </Grid>
            <Box pt={4} pb={2}>
              <Button
                variant="contained"
                color="primary"
                className={classes.buttonStyle}
                style={{ marginRight: 2 }}
                type="submit"
              >
                Save
              </Button>

              <Button
                variant="text"
                color="primary"
                className={classes.outlinedButtonStyle}
                onClick={() => navigate(`${project_url}/clients`)}
              >
                Cancel
              </Button>
            </Box>
          </form>
          {alertMsg.msg && (
            <AlertDialog
              title={alertMsg.title}
              contentMsg={alertMsg.msg}
              closeDialog={() => {
                setAlertMsg([]);
                alertMsg.title === "Success" && navigate(`${project_url}/clients`);
              }}
            />
          )}
        </div>
      </div>
    );
  else
      return (
        <div className={classes.root}>          
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.' 
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />
            
          </div>
        </div>
      );  
  else return;
  
}

export default ClientAdd;
